import type { RegistrationUserDataPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import type { User } from '@adornis/buchungsheld-db/entities/user.js';
import type { BHTranslationDictionary } from '@adornis/buchungsheld-db/translations/translation.js';
import type { GenericFieldFormController } from '@adornis/cms/client/generic-field-formcontroller.js';
import type { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { html } from 'lit';
import { type IcsrmFollowUpStammdaten } from '../stammdaten/icsrm-follow-up-stammdaten-plugin.js';

export const icsrmFollowUpRegistrationUserDataPlugin: RegistrationUserDataPlugin<IcsrmFollowUpStammdaten> = {
  id: 'registration::user-data::icsrm-follow-up',
  type: 'registration::user-data',
  extraUserFields: [],
  render: (
    stContr: GenericFieldFormController<IcsrmFollowUpStammdaten>,
    translationController: TranslationController<BHTranslationDictionary>,
    user: User,
  ) => {
    const genericFieldOption = (fieldName: string) =>
      ({
        placeholder: translationController.translate('icsrmFollowUp', 'field', fieldName as any) as string,
        placeholderMode: 'static-floating',
      } as const);

    return html`
      <x-flex space="lg">
        <x-flex space="md">
          <!-- Zuwanderungsgeschichte -->
          <tr-dropdown-selection
            ${stContr.field('isImmigrant')}
            placeholder=${translationController.translate('icsrmFollowUp', 'isImmigrantExpl') + '*'}
            .selectables=${[true, false]}
            .renderString=${key => translationController.translate(key ? 'yes' : 'no')}
          ></tr-dropdown-selection>

          <!-- Derzeitige Hochschule -->
          ${stContr.genericField(['currentUniversity'], genericFieldOption('currentUniversity'))}

          <!-- Contact consent -->
          <x-checkbox
            ${stContr.field('contactConsent')}
            label=${(translationController.translate('icsrmFollowUp', 'field', 'contactConsent') + '*') as string}
            required
          ></x-checkbox>
        </x-flex>
      </x-flex>
    `;
  },
};
